import * as React from "react";
import { useTranslation } from "react-i18next";
import PrwcTextButton from "../../../ui/widgets/custom/buttons/PrwcTextButton";
import NotificationItem from "../NotificationItem";

const Notifications = (props: any) => {
  const { data, onDismiss, onDismissAll } = props;
  const { t } = useTranslation();

  const handleOnDismiss = (notificationId: number) => {
    onDismiss(notificationId);
  };

  const handleDismissAll = () => {
    onDismissAll();
  };

  return (
    <div className="max-h-full overflow-auto">
      {data && data.length > 0 && (
        <div className="flex justify-end w-full">
          <PrwcTextButton
            onClick={handleDismissAll}
            className="p-button-text p-button-sm"
            labelKey="homeHeader.action.dismissAll"
          ></PrwcTextButton>
        </div>
      )}
      {data && data.length > 0 ? (
        data.map((notification: any, index: number) => (
          <NotificationItem
            key={index}
            onDismiss={handleOnDismiss}
            data={notification}
          ></NotificationItem>
        ))
      ) : (
        <div className="flex items-center justify-center h-40 text-sm text-gray-500 w-80">
          {t("homeHeader.label.notifications.noPendingNotifications")}
        </div>
      )}
    </div>
  );
};

export default Notifications;
